exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sort-Sort-Sort{font-size:13.6px;font-size:.85rem;margin:8px 0;margin:.5rem 0;width:100%}@media (min-width:721px){.Sort-Sort-Sort{margin:0;text-align:right}}", ""]);

// exports
exports.locals = {
	"Sort": "Sort-Sort-Sort"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/Sort/Sort.css
// module id = 1053
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20